// import { create } from 'zustand';

// const useLocationStore = create((set) => ({
//   provinceCode: null,
//   cityCode: null,
//   setProvinceCode: (code) => set({ provinceCode: code }),
//   setCityCode: (code) => set({ cityCode: code }),
//   clearLocations: () => set({ provinceCode: null, cityCode: null }),
// }));

// export default useLocationStore;
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const useLocationStore = create(
  persist(
    (set) => ({
      provinceCode: 2,
      cityCode: 3,
      setProvinceCode: (code) => set({ provinceCode: code }),
      setCityCode: (code) => set({ cityCode: code }),
      clearLocations: () => set({ provinceCode: null, cityCode: null }),
    }),
    {
      name: 'location-storage', // Unique key for localStorage
      storage: {
        getItem: (name) => {
          const value = localStorage.getItem(name);
          return value ? JSON.parse(value) : null;
        },
        setItem: (name, value) => localStorage.setItem(name, JSON.stringify(value)),
        removeItem: (name) => localStorage.removeItem(name),
      },
    }
  )
);

export default useLocationStore;